/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-14 16:37:06
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-14 16:45:21
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/ProductDetail/Components/SectionContent/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
const _SectionWrapper = (props) => {
  const { className, children, ...rest } = props;
  return (
    <SectionContent className={`${css.container} ${className}`} {...rest}>
      {children}
    </SectionContent>
  );
};
export default _SectionWrapper;
